export default __webpack_public_path__ + "static/magazijn-d72c84d74b83f014a3bda2cae8047419.jpg";